import { Metric, MetricChart, ChartDataResult } from '@gms/monitoring-api';
import { createInitialDataState, IDataState } from '../app/app.models';

export interface IMonitoringState {
  metricDefinitions: IDataState<Metric[], any>;
  metricCharts: IDataState<MetricChart[], any>;
  chartData: IDataState<ChartDataResult, any>;
}

export const initialMonitoringState: IMonitoringState = {
  metricDefinitions: createInitialDataState([]),
  metricCharts: createInitialDataState([]),
  chartData: createInitialDataState(null),
};